import { gql } from "@apollo/client";

import { USER_FIELDS } from "./users";

// Warning: loggedInInfo is not run within the context of any subaccount,
// so any fields it queries for must have the LOGGED_IN permission level, no
// higher (the only exception is fields on currentUser, which use the USER:SELF
// permission level).
//
// If you add any fields to the LOGGED_IN_INFO_FIELDS or TENANT_FIELDS fragments,
// update loggedInInfo.test.ts in the backend to ensure permissions are correctly
// set up for the new fields.

export const TENANT_FIELDS = gql`
  fragment TenantFields on Tenant {
    id
    name
    createdAt
    deactivatedAt
    slug
    subaccountsEnabled
    defaultSubaccount {
      id
      name
    }
    timezoneOptions {
      timezone
      displayName
    }
    optOutSharingEnabled
    autoMMSBreakpoint
    featureFlags
    mfaMinimumRole
  }
`;

const LOGGED_IN_INFO_FIELDS = gql`
  ${TENANT_FIELDS}
  ${USER_FIELDS}
  fragment LoggedInInfoFields on LoggedInInfo {
    currentUser {
      ...UserFields
    }
    currentSessionExpiresAt
    tenant {
      ...TenantFields
    }
    subaccountMemberships {
      id
      role
      createdAt
      subaccount {
        id
        name
        slug
        archivedAt
      }
    }
    tenantRoleSubaccountMemberships {
      role
      subaccount {
        id
        name
        slug
        archivedAt
      }
    }
    freshdeskSSOToken
    featureFlagDefaults
  }
`;

export const LOGGED_IN_INFO = gql`
  ${LOGGED_IN_INFO_FIELDS}
  query LoggedInInfo {
    loggedInInfo {
      ...LoggedInInfoFields
    }
  }
`;
